import(/* webpackMode: "eager" */ "/home/runner/actions-runner/_work/www/www/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/runner/actions-runner/_work/www/www/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/runner/actions-runner/_work/www/www/src/app/insights/_components/content-card.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/actions-runner/_work/www/www/src/components/contentful/contentful-image.tsx");
